<template>
  <div class="mine">
    <div class="mine-header">
      <div class="mine-header-text">
        <img src="../assets/default.png" alt="" />
        <div>
          <div style="display: flex; align-items: center">
            <span>{{ logon.userName }}</span>
            <el-tag
              type="success"
              effect="plain"
              style="
                font-size: 20px;
                margin-left: 10px;
                color: coral;
                cursor: pointer;
              "
              @click="openRechargeDialog"
              >充值</el-tag
            >
          </div>
          <div
            style="
              text-align: left;
              margin-top: 10px;
              color: coral;
              font-size: 20px;
            "
          >
            金币数:{{ logon.coins || "0" }}
          </div>
        </div>
      </div>
    </div>
    <div class="mine-content">
      <div class="mine-content-top">
        <div
          class="mine-content-top-item"
          v-for="(item, index) in headerList"
          :key="index"
          @click="handleClick(index + 1)"
          :style="
            active == index + 1 ? 'background:#F5F7FD' : 'background:#FFFFFF'
          "
        >
          <em v-if="active == index + 1"></em>
          <img :src="item.image" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="mine-content-list">
        <div
          class="mine-content-list-item"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <h1>{{ item.projectName }}</h1>
          <h2>{{ item.projectDescribe }}</h2>
          <h3>预算：{{ item.projectSpendStr }}</h3>
          <h4>期望交付周期：{{ item.expectDay }}天</h4>
          <em></em>
          <div
            class="mine-content-list-item-detail"
            :style="item.status == 1 ? '' : 'background:#96BBF8'"
            @click="handleUpdate(item)"
          >
            {{ item.status == 1 ? "编辑" : "审核中" }}
          </div>
        </div>
      </div>
      <el-pagination
        style="text-align: right"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        class="pagination"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :total="total"
        v-if="total > 0"
      >
      </el-pagination>

      <el-dialog
        title="金币充值"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
      >
        <div class="recharge-dialog">
          <!-- 标签页 -->
          <div class="tabs">
            <div
              class="tab-item"
              :class="{ active: activeTab === 'recharge' }"
              @click="activeTab = 'recharge'"
            >
              金币充值
            </div>
            <div
              class="tab-item"
              :class="{ active: activeTab === 'records' }"
              @click="activeTab = 'records'"
            >
              充值记录
            </div>
          </div>

          <!-- 标签内容 -->
          <div class="tab-content">
            <!-- 金币充值 -->
            <div v-if="activeTab === 'recharge'" class="recharge-form">
              <div class="form-item">
                <label style="text-align: left"
                  >请输入要充值的金币数 (一次最小需要充值10个金币)</label
                >
                <div class="input-group">
                  <el-input
                    v-model.number="coins"
                    type="number"
                    min="10"
                    style="width: 100px"
                  ></el-input>
                  <span class="coin-rate">(1元=1金币)</span>
                </div>
              </div>
              <div class="form-item">
                <label>实际应付</label>
                <div class="payment-amount">{{ actualPayment }}元</div>
              </div>
              <div class="form-item">
                <label>请选择支付方式</label>
                <div class="payment-methods">
                  <div class="payment-option active">
                    <img src="../assets/zfb.png" alt="支付宝" />
                  </div>
                </div>
              </div>
              <el-button
                type="primary"
                class="confirm-btn"
                @click="handleRecharge"
                style="background-color: #ff6b00; border-color: #ff6b00"
                >确认充值</el-button
              >
              <div class="recharge-notes">
                <p>1. 充值通用与金币比例为1:1，即充值1元可购买1个金币</p>
                <p>
                  2.
                  若出现已成功充值的提示，但金币未到账，可能是网速或系统繁忙导致，我们会在2个工作日内核对后为您充值。
                </p>
                <p>3. 在充值时请仔细确认充值的金额和账户，以免为充值错误;</p>
                <p>
                  4.
                  在充值过程中如出现网页错误或打开缓慢时，请先查询银行或者相关支付方式的交易记录，检查扣款是否成功；然后查看账户是否已成功充值。
                </p>
              </div>
            </div>

            <!-- 充值说明 -->
            <div
              v-if="activeTab === 'instructions'"
              class="recharge-instructions"
            >
              <div class="recharge-notes">
                <p>1. 充值通用与金币比例为1:2，即充值1元可购买2个金币</p>
                <p>
                  2.
                  若出现已成功充值的提示，但金币未到账，可能是网速或系统繁忙导致，我们会在2个工作日内核对后为您充值。
                </p>
                <p>3. 在充值时请仔细确认充值的金额和账户，以免为充值错误;</p>
                <p>
                  4.
                  在充值过程中如出现网页错误或打开缓慢时，请先查询银行或者相关支付方式的交易记录，检查扣款是否成功；然后查看账户是否已成功充值。
                </p>
              </div>
            </div>

            <!-- 充值记录 -->
            <div v-if="activeTab === 'records'" class="recharge-records">
              <p v-if="alipayList.length === 0">暂无充值记录</p>
              <div v-else>
                <!-- <div
                  v-for="item in alipayList"
                  :key="item.id"
                  class="record-item"
                >
                  <div class="record-info">
                    <span class="record-time">{{
                      formatTime(item.createTime)
                    }}</span>
                    <span class="record-amount">{{ item.amount }}元</span>
                  </div>
                  <div class="record-status">
                    <span v-if="item.status === 1" class="status-success"
                      >已充值</span
                    >
                    <span v-else class="status-pending">未支付</span>
                  </div>
                </div> -->

                <el-table :data="alipayList" stripe style="width: 100%">
                  <el-table-column type="index" width="150" label="序号"> </el-table-column>
                  <el-table-column label="订单日期" width="300">
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span style="margin-left: 10px">{{
                        formatTime(scope.row.createTime)
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="outTradeNo" label="订单号" width="300">
                  </el-table-column>
                  <el-table-column prop="amount" label="充值金额" width="180">
                  </el-table-column>
                  <el-table-column label="订单状态">
                    <template slot-scope="scope">
                      <el-tag size="medium" type="success" v-if="scope.row.status == 1">{{
                        "已充值"
                      }}</el-tag>
                      <el-tag size="medium" type="info" v-else>{{ "未支付" }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import mine1 from "../assets/mine1.png";
import mine2 from "../assets/mine2.png";
import mine3 from "../assets/mine3.png";
import mine4 from "../assets/mine4.png";
import {
  getMine,
  aliPayPcRecharge,
  aliPayPcRechargeList,
} from "../utils/publish";

export default {
  data() {
    return {
      logon: undefined,
      headerList: [
        {
          name: "广告策划",
          image: mine1,
        },
        {
          name: "企业咨询",
          image: mine2,
        },
        {
          name: "数字内容制作",
          image: mine3,
        },
        {
          name: "系统平台搭建",
          image: mine4,
        },
      ],
      type: 1,
      total: 0,
      pageNo: 1,
      pageSize: 3,
      dataList: [],
      active: 1,
      dialogVisible: false,
      coins: 10,
      selectedPayment: "alipay",
      activeTab: "recharge",
      alipayList: [], // 充值记录列表
      alipayList: [],
    };
  },
  computed: {
    actualPayment() {
      return this.coins;
    },
    // 格式化时间
  },
  created() {},
  methods: {
    formatTime(timeStr) {
      if (!timeStr) return "";
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    openRechargeDialog() {
      this.dialogVisible = true;
    },
    getaliPayPcRechargeList() {
      aliPayPcRechargeList().then((res) => {
        console.log(res, "--255--");
        if (res.data.code == 200) {
          this.alipayList = res.data.data || [];
        }
      });
    },
    handleRecharge() {
      // 处理充值逻辑
      console.log(
        "确认充值",
        this.coins,
        "金币，支付",
        this.actualPayment,
        "元",
      );

      // 调用后端充值接口
      aliPayPcRecharge({
        money: this.actualPayment,
      }).then((res) => {
        console.log(res, "--255--");
        if (res.data.code == 200) {
          console.log(res, "---258----");
          // 检查返回数据是否为form结构
          if (
            typeof res.data.data === "string" &&
            res.data.data.includes("<form")
          ) {
            // 创建临时form并提交
            this.submitAlipayForm(res.data.data);
            this.getList();
          } else {
            this.$message.success("充值成功");
            this.dialogVisible = false;
          }
        } else if (res.data.code == 208) {
          this.$message.success("登录已经失效，请重新登录!");
          setTimeout(() => {
            localStorage.removeItem("loginstate"), this.$router.push("/login");
          }, 1500);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 提交支付宝form
    submitAlipayForm(formStr) {
      // 创建临时div
      const tempDiv = document.createElement("div");
      tempDiv.style.display = "none";
      tempDiv.innerHTML = formStr;
      document.body.appendChild(tempDiv);

      // 获取form并提交
      const form = tempDiv.querySelector("form");
      if (form) {
        form.submit();
      }

      // 延迟移除临时div
      setTimeout(() => {
        document.body.removeChild(tempDiv);
      }, 1000);

      // 关闭对话框
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClick(tab) {
      this.$nextTick(() => {
        this.active = tab;
        this.type = tab;
        this.pageNo = 1;
        this.getList();
      });
    },
    handleUpdate(item) {
      if (item.status == 1) {
        this.$router.push({ path: "/publish", query: { id: item.id } });
      }
      return;
    },
    // 分页
    handleCurrentChange(page) {
      this.pageNo = page;
      this.getList();
    },
    getList() {
      let data = {
        currentPage: this.pageNo,
        pageSize: this.pageSize,
        type: this.type,
      };
      getMine(data).then((res) => {
        if (res.data.code == 200) {
          this.$nextTick(() => {
            this.dataList = res.data.data;
            this.total = res.data.total;
          });
        } else if (res.data.code == 208) {
          this.$message.success("登录已经失效，请重新登录!");
          setTimeout(() => {
            localStorage.removeItem("loginstate"), this.$router.push("/login");
          }, 1500);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  created() {
    this.logon = JSON.parse(localStorage.getItem("loginstate"));
    this.getaliPayPcRechargeList();
  },
  activated() {
    if (this.$route.query && this.$route.query.type) {
      this.active = Number(this.$route.query.type);
      this.type = Number(this.$route.query.type);
    } else {
      this.active = 1;
      this.type = 1;
    }
    this.pageNo = 1;
    this.getList();
  },
};
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.mine {
  width: 100%;
  &-header {
    width: 100%;
    height: 400px;
    background: url("../assets/mine.png") no-repeat;
    background-size: cover;
    display: flex;
    &-text {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 190px;
      img {
        width: 132px;
        height: 132px;
        margin-right: 30px;
      }
      span {
        .fontdemo(35px,"AlibabaPuHuiTi_2_75_SemiBold",600,#000000);
      }
      el-tag {
        margin-left: 10px;
        font-size: 20px !important;
      }
    }
  }
  &-content {
    width: 100%;
    padding: 0 190px 114px;
    box-sizing: border-box;
    background: url("../assets/cover.png") no-repeat;
    background-size: cover;
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: -70px;
      &-item {
        width: 24%;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        em {
          width: 100%;
          height: 6px;
          background: #4787f0;
          position: absolute;
          bottom: 0;
        }
        img {
          width: 144px;
          height: 108px;
          margin-right: 26px;
        }
        span {
          .fontdemo(24px,"AlibabaPuHuiTi_2_75_SemiBold",600,#000000);
        }
      }
    }
    &-list {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 33px;
      &-item {
        width: 32%;
        box-sizing: border-box;
        padding: 40px 44px;
        text-align: left;
        background: #ffffff;
        margin-bottom: 52px;
        margin-right: 2%;
        h1 {
          .fontdemo(22px, "PingFangSC,PingFang SC", 600, #000000);
          margin: 20px 0 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          width: 70%;
        }
        h2 {
          .fontdemo(20px, "PingFangSC,PingFang SC", 400, rgba(0,0,0,0.85));
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 8;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          height: 205px;
        }
        h3 {
          .fontdemo(18px, "PingFangSC,PingFang SC", 400, #566781);
          margin: 27px 0 8px;
        }
        h4 {
          .fontdemo(18px, "PingFangSC,PingFang SC", 400, #566781);
        }
        em {
          width: 100%;
          height: 1px;
          border-bottom: 1px solid #e7e7e7;
          display: block;
          margin: 25px 0 20px;
        }
        &-detail {
          width: 110px;
          height: 40px;
          background: #4787f0;
          border-radius: 8px;
          .fontdemo(16px, "PingFangSC,PingFang SC", 500, #FFFFFF);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: auto;
          cursor: pointer;
        }
      }
      :nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.pagination {
  margin: 10px auto 0px;
}
/deep/ .el-pager li {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  margin: 0 13px;
}
/deep/ .el-pager .active {
  background: #0052d9;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}
/deep/ .btn-prev {
  width: 40px;
  height: 40px;
}
/deep/ .btn-next {
  width: 40px;
  height: 40px;
}
.recharge-dialog {
  padding: 20px 0;

  /* 标签页样式 */
  .tabs {
    display: flex;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
    .tab-item {
      padding: 10px 20px;
      cursor: pointer;
      margin-right: 10px;
      border-bottom: 2px solid transparent;
      &.active {
        background-color: #f5f5f5;
        font-weight: bold;
      }
    }
  }

  /* 充值表单 */
  .recharge-form {
    text-align: left;
    .form-item {
      margin-bottom: 20px;
      label {
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .input-group {
        display: flex;
        align-items: center;
        .coin-rate {
          margin-left: 10px;
          color: #666;
        }
      }
      .payment-amount {
        font-size: 18px;
        color: #ff6b00;
        font-weight: bold;
      }
      .payment-methods {
        .payment-option {
          display: flex;
          margin-right: 20px;
          padding: 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          cursor: pointer;
          flex-wrap: wrap;
          width: 200px;
          &.active {
            border-color: #ff6b00;
            background-color: #fff9f0;
          }
          input {
            margin-right: 10px;
          }

          img {
            width: 200px;
            height: 80px;
            margin-right: 10px;
          }
        }
      }
    }
    .confirm-btn {
      margin-top: 20px;
      width: 120px;
      height: 40px;
      font-size: 16px;
    }
  }

  /* 充值说明 */
  .recharge-notes {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 4px;
    p {
      margin: 8px 0;
      font-size: 14px;
      color: #666;
      line-height: 1.4;
    }
  }

  /* 充值记录 */
  .recharge-records {
    padding: 20px 0;
    .record-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }
      .record-info {
        display: flex;
        flex-direction: column;
        .record-time {
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }
        .record-amount {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }
      }
      .record-status {
        .status-success {
          color: #67c23a;
          font-size: 14px;
        }
        .status-pending {
          color: #e6a23c;
          font-size: 14px;
        }
      }
    }
    p {
      text-align: center;
      color: #999;
      padding: 40px 0;
    }
  }

  /* 充值说明标签 */
  .recharge-instructions {
    padding: 20px 0;
  }
}

::v-deep .el-tabs__header {
  background-color: #f5f5f5;
  text-align: left !important;
}
</style>
